import { render, staticRenderFns } from "./dataV1.vue?vue&type=template&id=48710df5&scoped=true&"
import script from "./dataV1.vue?vue&type=script&lang=js&"
export * from "./dataV1.vue?vue&type=script&lang=js&"
import style0 from "./dataV1.vue?vue&type=style&index=0&id=48710df5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48710df5",
  null
  
)

export default component.exports